module.exports = __webpack_public_path__ + "static/media/image-1.13f994dd.png";